import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import { useEffect, useState } from 'react';

import { isExternalSession } from '../../utils/helpers';

const useStyles = makeStyles({
    menu: {
        marginTop: '2.19rem',
    },
});

export const ProfilSubmenu = ({ isSubmenu, setIsSubmenu, onChangePassword, onLogout }) => {
    const { menu } = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClose = () => {
        setAnchorEl(null);
        setIsSubmenu(null);
    };

    const handleAction = action => {
        handleClose();
        action();
    };

    useEffect(() => {
        setAnchorEl(isSubmenu);
    }, [isSubmenu]);

    return (
        <Menu className={menu} anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
            {!isExternalSession() && (
                <MenuItem onClick={() => handleAction(onChangePassword)}>Zmień hasło</MenuItem>
            )}
            <MenuItem onClick={() => handleAction(onLogout)}>Wyloguj</MenuItem>
        </Menu>
    );
};

export default ProfilSubmenu;
